import request from '@/request'

export function List(query) {
  return request({
    url: '/index/product',
    method: 'get',
    params:query
  })
}

export function Detail(query) {
  return request({
    url: '/index/proudctDetail',
    method: 'get',
    params: query
  })
}

export function Categroy(query) {
  return request({
    url: '/index/Productcategroy',
    method: 'get',
    params:query
  })
}
export function productCategroyDetail(query) {
  return request({
    url: '/index/productCategroyDetail',
    method: 'get',
    params: query
  })
}



